import axios from 'axios'
import { init } from '../plugins/localStorage'
import config from '@/helpers/config'

const state = {
  token: init,
  user: {}
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },
  resetToken (state) {
    state.token = ''
  },
  setUser (state, user) {
    state.user = user
  },
  resetUser (state) {
    state.user = {}
  }
}

const actions = {
  async login ({ commit }, user) {
    const endpoint = config.apiUrl + '/users/login/admin'
    const { data } = await axios.post(endpoint, user)
    commit('setToken', data.payload.token)
    commit('setUser', data.payload.user)
  },
  logout ({ commit }) {
    commit('resetToken')
    commit('resetUser')
  }
}

const getters = {
  isLoggedIn (state) {
    if (!state.token) {
      return false
    } else {
      return true
    }
  },
  currentUser (state) {
    if (!state.token) {
      return {}
    } else {
      return state.user
    }
  },
  currentToken (state) {
    if (!state.token) {
      return {}
    } else {
      return state.token
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js